import { i18n } from '@lt/localization';
import React from 'react';

import MultichoiceFilterGroup from '../../../../../../../components/Filters/components/MultichoiceFilterGroup';
import type { ExtendedFilterInfo, CommonFilterProps } from '../types';

const FilterTransitionsCount = (props: CommonFilterProps) => (
  <MultichoiceFilterGroup {...props} Filter={FilterTransitionsCount} />
);

const filterNames = {
  0: i18n.t('checkout.filter.transitions.name_zero'),
  1: i18n.t('checkout.filter.transitions.name_one'),
  2: i18n.t('checkout.filter.transitions.name_two'),
};

FilterTransitionsCount.getFilterVisibleName = (
  filterOptionData: ExtendedFilterInfo,
) =>
  filterOptionData.id !== undefined ? filterNames[filterOptionData.id] : '';

FilterTransitionsCount.filterName = 'transitions_count';
FilterTransitionsCount.filterLabel = i18n.t(
  'checkout.filter.transitions.countLabel',
);

export default FilterTransitionsCount;
